import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import OrderCard from './orderCard/OrderCard';
import BasicPagination from 'src/common/refactoredComponents/paginator';
import media, { sizes } from 'src/styles/Media.styled';
import {
    setOrdersListFilter,
    getRefinedOrderListData,
    actionApplyFilterType,
    showHideRequestInvoice,
    showHideSearchModalAction,
} from 'src/pages/orders/redux/actions';
import BottomNavigation from 'src/common/refactoredComponents/bottomNavigation/BottomNavigation';
import RequestInvoice from 'src/pages/orders/components/reportsAndInvoice/requestInvoice/RequestInvoice';
import {
    checkTemplateReviewUserRoleChanges,
    convertDateToISOString,
    getUserDetails,
} from 'src/utils/util';
import {
    ENVIRONMENTVARIABLE,
    SURGERY_TEMPLATE_MANDATORY_FIELDS,
} from 'src/constants/appConstants';
import { useTranslation } from 'react-i18next';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
 
const OrdersListCardView = (props) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { orderList } = useSelector((state) => state.ordersListReducer);
    const { loading } = useSelector((state) => state.ordersListReducer);
    const [page, setPage] = useState(0);
    const [first, setFirst] = useState(0);
    const [pageControl, setPageControl] = useState(false);
    const [innerWidth, setInnerWidth] = useState(window.innerWidth);
    const [, setInnerHiehgt] = useState(window.innerHeight);

    const scrollElementToTop = (element) => {
        if (!element) return false;
        element.scrollTop = 0;
        element.scrollLeft = 0;
        if (typeof element.scrollTo === 'function') {
            element.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        }
        return true;
    };

    const scrollViewportToTop = () => {
        const ordersContainer = document.getElementById('ordersContainer');
        if (scrollElementToTop(ordersContainer)) return;
        const scrollingElement = document.scrollingElement || document.documentElement || document.body;
        scrollElementToTop(scrollingElement);
        if (typeof window.scrollTo === 'function') {
            window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        }
    };

    const {
        requestInvoiceState,
        isRequestInvoiceSearchListPage,
        isRequestInvoiceOrderListPage,
    } = useSelector((state) => state.orderSummaryReducer);

    const openSummaryHandler = (myCaseRef, orderType, isUsageMastOrder, isMastOrder) => {
        props.openOrderSummaryHandler(myCaseRef, orderType, isUsageMastOrder, isMastOrder);
    };
    const appliedUserFilters = useSelector(
        (state) => state.appliedOrdersFilterReducer
    );
    const { qrGenerated } = useSelector(
            (state) => state.qrCodeReducer
        );
    const { isFilterType } = useSelector((state) => state.orderFilterReducer);

    const employeeRole = getUserDetails();

    useEffectWithErrorLogging(() => {
        if (
            isFilterType !== 'delete' &&
            isFilterType !== 'pagination' &&
            isFilterType !== 'pageSort'
        ) {
            setPage(0);
            setFirst(0);
        }
    }, [isFilterType]);

    const onPageChange = (event) => {
        setFirst(event.first);
        setPage(event.page);
        setPageControl(true);
        scrollViewportToTop();
    };
    useEffectWithErrorLogging(() => {
        if (pageControl) {
            dispatch(actionApplyFilterType('pagination'));
            dispatch(
                setOrdersListFilter({
                    ...appliedUserFilters,
                    startDate: convertDateToISOString(
                        new Date(props.firstOrderStartDate),
                        'start'
                    ),
                    pageNo: page,
                    pageLimit: appliedUserFilters.pageLimit,
                })
            );
            dispatch(
                getRefinedOrderListData({
                    ...appliedUserFilters,
                    startDate: convertDateToISOString(
                        new Date(props.firstOrderStartDate),
                        'start'
                    ),
                    pageNo: page,
                    pageLimit: appliedUserFilters.pageLimit,
                      isFromOrderHistory:props?.isOrderHistory,
                })
            );
            setPageControl(false);
        }
    }, [page]);

    const isMobile = innerWidth <= sizes.mobileDevice ? true : false;

    window.onresize = () => {
        setInnerWidth(window.innerWidth);
        setInnerHiehgt(window.innerHeight);
    };

    const onCloseRequestInvoiceHandler = () => {
        if (isRequestInvoiceSearchListPage) {
            dispatch(
                showHideSearchModalAction({
                    showSearchModal: true,
                })
            );
        }
        dispatch(
            showHideRequestInvoice({
                requestInvoiceState: false,
                myCaseRefId: '',
                isRequestInvoiceOrderListPage: false,
                isRequestInvoiceSearchListPage: false,
            })
        );
    };

    return (
        <OrderCardsContainer>
            {loading ? null : (
                <>
                    <Ordercard>
                        {orderList?.map((order, index) => {
                            return (
                                <OrderCard
                                    key={order.myCaseRef}
                                    {...order}
                                    isUsSurgeryNT = {order?.currentOrderType=='ZLC' ? order?.isNonTissueExists : false}
                                    isUsSurgeryT = {order?.currentOrderType=='ZLC' ? order?.isTissueExists : false}
                                    openOrderSummaryHandler={() => openSummaryHandler(order.myCaseRef, order?.currentOrderType, order?.isUsageMastOrder, order?.isMastOrder)}
                                    mbMarginBottom={
                                        orderList.length - 1 == index && '360px'
                                    }
                                    templateMandatoryFields={checkTemplateReviewUserRoleChanges(
                                        employeeRole,
                                        SURGERY_TEMPLATE_MANDATORY_FIELDS
                                    )}
                                   
                                    setNotificationDetails={props?.setNotificationDetails}
                                    notificationDetails={props?.notificationDetails}
                                    isHistory={props?.isOrderHistory}
                                    qrGenerated={order?.qrGenerated}
                                    torqueRecorded={order?.torqueRecorded}
                                    qrGeneratedFromState={qrGenerated}
                                />
                            );
                        })}
                    </Ordercard>
                    <BottomNavigation
                        padding={'0px'}
                        mbPadding={'0px'}
                        mbPosition={'fixed'}
                        zIndex={1}
                    >
                        <PaginationContainerMobile padding={'0px'}>
                            <BasicPagination
                                totalRecords={+props.totalNumberOfRecords}
                                recordsFetched={
                                    orderList?.length > 0
                                        ? +orderList.length
                                        : 0
                                }
                                pageNumber={page}
                                handleChange={(e) => onPageChange(e)}
                                first={first}
                                mobilePadding={'2% 2% 2% 2%'}
                                content={t('orders.searchOrdersPanel.ShowingOrders')}
                            />
                        </PaginationContainerMobile>
                    </BottomNavigation>
                    {/* <EmptyBox mobileMargin="0 0 15% 0"></EmptyBox> */}
                </>
            )}
            {isMobile &&
                requestInvoiceState &&
                (isRequestInvoiceOrderListPage ||
                    isRequestInvoiceSearchListPage) && (
                    <RequestInvoice
                        onCloseRequestInvoiceHandler={
                            onCloseRequestInvoiceHandler
                        }
                    />
                )}
        </OrderCardsContainer>
    );
};

export default OrdersListCardView;

const OrderCardsContainer = styled.div`
    margin: 0;
    display: flex;
    flex-direction: column;
    width: 100%;
    ${media.mobileDevice`
        margin-top: 2%;
        min-height: 70vh;
    `}
`;

export const SpinnerContainer = styled.div`
    height: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
`;
export const PaginationContainerMobile = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0px;
    width: 100%;
    ${media.mobileDevice`
        flex-direction:column;
        margin: 10px 0px 0px 0px;
        justify-content: space-between;
        padding-bottom:${({ padding }) =>
            ENVIRONMENTVARIABLE ? '0px' : padding ? padding : '1.125rem'} 
    `}
`;
export const Ordercard = styled.div`
    display: flex;
    flex-direction: column;
`;
